import { render } from "./files_verifications.vue?vue&type=template&id=7960e806"
import script from "./files_verifications.vue?vue&type=script&lang=js"
export * from "./files_verifications.vue?vue&type=script&lang=js"

import "./files_verifications.vue?vue&type=style&index=0&id=7960e806&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__